// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__N55eA","description":"PageContent_description__balrG"};